<template>
    <div class="container pb-2 pt-1">
        <div class="row" v-if="!selectedType">
            <div class="col-12 text-center">
                <h4>Select a repair kit type to pick:</h4>
            </div>
            <div class="col-12 mb-1">
                <button class="btn btn-success btn-block d-md-inline-block mb-1 w-full" @click="emitSearchValue('all')">All Kit Types ({{ getCountForKitType('all') }})</button>
            </div>
            <div class="col-12 mb-1">
                <button class="btn btn-success btn-block d-md-inline-block mb-1 w-full" @click="emitSearchValue('fleet')">Fleet Kits ({{ getCountForKitType('fleet') }})</button>
            </div>
            <div class="col-12 mb-1">
                <button class="btn btn-success btn-block d-md-inline-block mb-1 w-full" @click="emitSearchValue('in_house')">In-House Kits ({{ getCountForKitType('in_house') }})</button>
            </div>
          <div v-if="localAU" class="col-12 mb-1">
                <button class="btn btn-success btn-block d-md-inline-block mb-1 w-full" @click="emitSearchValue('uplift')">Bulk Refurb/Uplift ({{ getCountForKitType('uplift') }})</button>
          </div>
            <div class="col-12 mb-1">
                <button class="btn btn-success btn-block d-md-inline-block mb-1 w-full" @click="emitSearchValue('fsl')">FSL Kits ({{ getCountForKitType('fsl') }})</button>
            </div>
        </div>
        <div class="row" v-if="selectedType">
            <div class="col-12 text-center">
                <h4>{{ selectedType }} Repair Kits</h4>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-success btn-block d-md-inline-block mb-0 w-full" @click="resetPickingFilterSelection()">Change Selections</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        searchValue: {
            default: ""
        },
        repairKitsToBePicked: {
            default: ""
        },
    },

    data() {
        return {
            selectedType: null,
        }
    },

    mounted() {
        if(localStorage.getItem('selectedKitType') && localStorage.getItem('selectedKitType') != 'undefined') {
            this.selectedType = localStorage.getItem('selectedKitType');
        }

        this.emitSearchValue(this.selectedType);
    },

    computed: {
      localAU(){
        return process.env.VUE_APP_COUNTRY_CODE === 'AU'
      },
    },

    methods: {
        resetPickingFilterSelection() {
            this.selectedType = null;
            this.emitSearchValue(null);
        },

        getCountForKitType(kitType) {
            if (kitType === 'all') {
                return this.repairKitsToBePicked.length;
            }
            return this.repairKitsToBePicked.filter((item) => item.kit_type == kitType).length;
        },

        /** Pass searched value to parent */
        emitSearchValue(type) {
            this.selectedType = type;
            this.$emit("update:searchValue", {type: type});
            localStorage.setItem('selectedKitType', type);
        }
    }
}
</script>

<style scoped>
.w-full {
    width: 100% !important;
}
</style>